import type { IToastMessage } from '../../toast/interface';

const TOAST_KEY = 'ToastMessage-OfflineNotification';
const TOAST_TEXT = 'Currently offline, no internet connection';
const TOAST_TYPE = 'warn';

export const TOAST_MESSAGE: Required<IToastMessage> = {
    id: TOAST_KEY,
    text: TOAST_TEXT,
    type: TOAST_TYPE,
};
